import { CatalogueContentReference } from "../../../common/types/CatalogueContentReference";
import { ContentReferenceType } from "../../../common/types/ContentReferenceType";

export type LookupContentItem = CatalogueContentReference & {
    distributor: string;
    versionType: string;
    brandings: string[];
};

export const mapToLookupContentItem = (response: CatalogueContentReference): LookupContentItem => {
    return {
        ...response,
        distributor: response.version.distributor.name,
        versionType: response.version.type.name,
        brandings: mapToBrandings(response)
    };
};

const mapToBrandings = (content: CatalogueContentReference): string[] => {
    switch (content.type) {
        case ContentReferenceType.Movie:
        case ContentReferenceType.TvSeries:
            return content.version.brandings?.map((branding) => branding.name) ?? [];
        case ContentReferenceType.Ancillary:
            return content.version.airlines?.map((airline) => airline.name) ?? [];
        default:
            return [];
    }
};
